import { OfferQuery } from '@1bill-app/services/offer/offer.query';
import { OfferService } from '@1bill-app/services/offer/offer.service';
import { OfferStore } from '@1bill-app/services/offer/offer.store';
import { Offer } from '@1bill-app/services/offer/offer.type';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';

/**
 * Page for displaying an offer
 */
@Component({
  selector: 'app-offer-detail-modal',
  templateUrl: './offer-detail.page.html',
  styleUrls: ['./offer-detail.page.scss'],
})
export class OfferDetailPageModalComponent implements OnInit {
  @Input() url: string;
  offerDetails$: Observable<Offer> = this.offerQuery.offerDetails$;
  offerId: number;

  constructor(
    private route: ActivatedRoute,
    private logger: NGXLogger,
    private offerService: OfferService,
    private offerStore: OfferStore,
    private offerQuery: OfferQuery,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit() {}

  async closeModal() {
    await this.modalCtrl.dismiss(true);
  }
}
